import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  Input,
  useToast
} from '@chakra-ui/react'
import { useState, useEffect } from 'react'

import { IKnowledgeAreaFormModalProps } from '../../../../interfaces/KnowledgeArea/KnowledgeArea'

export function KnowledgeAreaFormModal({ isOpen, onClose, editing, onSave }: IKnowledgeAreaFormModalProps) {
  const [name, setName] = useState('')
  const toast = useToast()

  useEffect(() => {
    if (editing) setName(editing.name)
    else setName('')
  }, [editing])

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()

    if (!name.trim()) {
      toast({
        title: 'Erro',
        description: 'O nome é obrigatório',
        status: 'error',
        duration: 3000,
        isClosable: true
      })
      return
    }
    try {
      await onSave(name, editing?.id)
      onClose()
    } catch {
      toast({
        title: 'Erro',
        description: 'Não foi possível salvar a área de conhecimento',
        status: 'error',
        duration: 3000,
        isClosable: true
      })
    }
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{editing ? 'Editar Área de Conhecimento' : 'Adicionar Área de Conhecimento'}</ModalHeader>
        <ModalCloseButton />
        <form onSubmit={handleSubmit}>
          <ModalBody>
            <FormControl>
              <FormLabel>Nome</FormLabel>
              <Input value={name} onChange={(e) => setName(e.target.value)} autoFocus />
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button type="button" mr={3} onClick={onClose}>
              Cancelar
            </Button>
            <Button type="submit" colorScheme="magenta">
              Salvar
            </Button>
          </ModalFooter>
        </form>
      </ModalContent>
    </Modal>
  )
}
